import { createStyles, makeStyles } from '@material-ui/core/styles';
import { variables } from '../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    listItem: {
      padding: 0,
    },
    listItemExpand: {
      padding: 0,
    },
    expanded: {
      margin: '4px 8px',
      backgroundColor: variables.white,
      borderRadius: 8,
    },
    ltr: {
      right: '1rem',
    },
    rtl: {
      left: '1rem',
    },
    menuButton: {
      fontSize: 16,
      fontWeight: 600,
      width: 288,
      height: 56,
      textAlign: 'start',
      color: variables.richBlack,
      justifyContent: 'flex-start',
      verticalAlign: 'middle',
      '& .MuiButton-startIcon': {
        marginBottom: 2,
        marginInlineStart: -4,
        marginInlineEnd: 8,

        '& .MuiSvgIcon-root': {
          fontSize: 17,
        },
      },

      '& .MuiButton-endIcon': {
        position: 'absolute',
        right: '1rem',
        marginInlineEnd: '-10px',
        marginInlineStart: 8,
      },

      '@media (hover: hover) and (pointer: fine)': {
        '&:hover': {
          backgroundColor: 'unset',
          color: variables.black50,
          '& .MuiButton-startIcon': {
            '& svg path': {
              stroke: variables.black50,
            },
          },
        },
      },
    },
    subList: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    subListItem: {
      padding: 0,
    },
    subMenuButton: {
      color: variables.richBlack,
      height: 'fit-content',
      width: 288,
      fontSize: 14,
      fontWeight: 400,
      textAlign: 'start',
      justifyContent: 'flex-start',
      paddingInlineStart: 66,

      '@media (hover: hover) and (pointer: fine)': {
        '&:hover': {
          backgroundColor: 'unset',
          color: variables.black50,
        },
      },
    },

    collapsableMenuItem: {
      margin: '4px 0',
    },
  }),
);
